module.exports = __webpack_public_path__ + "static/04_co-design-workshop.7b5c0eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/04_co-design-workshop.jpg
// module id = 479
// module chunks = 110568472390859